import axios from "axios";
import config from "../app.json";

import "./Styles/AwsConnectionUpdate.scss";
import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Button } from "react-bootstrap";
import AlertComponent from "./AlertComponent";
import FieldText from "./Fields/FieldText";
import ModalComponent from "./ModalComponent";
import YoutubeVideoPlayer from "./YoutubeVideoPlayer";
import FieldSelect from "./Fields/FieldSelect";
import { Context } from "../Reducers/Store";

import ExternalLinkIcon from "../Assets/Images/external-link1.png"

const ChurchInfoAwsConnectionUpdate = () => {
  const [state, dispatch] = useContext(Context);
  const [awsKeyId, setAwsKeyId] = useState(null);
  const [awsSecretKey, setAwsSecretKey] = useState(null);
  const [showLearnVideo, setShowLearnVideo] = useState(false);
  const [timezones, setTimezones] = useState([]);
  const [timezone, setTimezone] = useState(null);

  useEffect(() => {
    axios.post(config.API + "/api/general/getTimezones").then((resTimezones) => {
      setTimezones(resTimezones.data.$values);
    }).catch(function (error) {
      return AlertComponent("Error", error?.response?.data?.error || error?.message, { icon: `error` });
    });
  }, [0]);

  useEffect(() => {
    if (timezones != null && timezones.length > 0)
      axios.post(config.API + "/api/church/getBasicChurch").then((res) => {
        dispatch({ type: "SET_CHURCH", payload: res.data });
        const timezoneItem = timezones.filter(x => x.value == res.data.timezone).at(0);
        setTimezone(timezoneItem);
      }).catch(function (error) {
        return AlertComponent("Error", error?.response?.data?.error || error?.message, { icon: `error` });
      });
  }, [timezones]);

  const handleUpdateTimezone = () => {
    if (timezone == null || timezone.value == null)
      return AlertComponent("Error", "Timezone is required", {
        icon: `error`,
      });
    axios.post(config.API + "/api/church/updateTimezone", {
      timezone: timezone.value
    }).then((res) => {
      dispatch({ type: "SET_CHURCH", payload: res.data });
      return AlertComponent("Success", "Your timezone has been updated");
    }).catch(function (error) {
      return AlertComponent("Error", error?.response?.data?.error || error?.message, { icon: `error` });
    });

  }

  const handleShowVideo = () => {
    setShowLearnVideo(true);
  };

  const handleUpdateKeys = () => {
    if (!awsKeyId) {
      return AlertComponent("Error", "AWS Access key ID is required", {
        icon: `error`,
      });
    }

    if (!awsSecretKey) {
      return AlertComponent("Error", "AWS Secret access key is required", {
        icon: `error`,
      });
    }
    axios
      .post(config.API + "/api/church/updateawskeys", {
        accessKey: awsKeyId,
        secretKey: awsSecretKey,
      })
      .then((res) => {
        if (res.status === 200) {
          return AlertComponent(
            "Success",
            "Your AWS credential has been updated"
          );
        }
      })
      .catch(function (error) {
        return AlertComponent(
          "Error",
          error?.response?.data?.error || error?.message,
          { icon: `error` }
        );
      });
  };

  return (
    <Row className="">
      <ModalComponent
        className="youtube-modal"
        data={<YoutubeVideoPlayer videoId={config.YoutubeVideo} />}
        modalIsOpen={showLearnVideo}
        setModalIsOpen={setShowLearnVideo}
      />
      <Col md={8} className="mt-4 mb-4">
        <div className="cc-card ">
          <Row>
            <Col md={9}>
              <h2>AWS Connection</h2>
            </Col>
            <Col md={3} style={{ display: "flex", justifyContent: "right" }}>
              <span
                className="learn-link"
                onClick={handleShowVideo}
              ><img src={ExternalLinkIcon} />{`Learn how to do it. ;)`}</span>
            </Col>
          </Row>
          <Row>
            <Col md={5}>
              <FieldText
                label="Your AWS Access key ID"
                type="text"
                onChange={(x) => setAwsKeyId(x.target.value)}
                placeholder="Enter user's access key ID"
                value={awsKeyId}
                required={true}
              />
            </Col>
            <Col md={5}>
              <FieldText
                label="Your AWS Secret access key"
                type="text"
                onChange={(x) => setAwsSecretKey(x.target.value)}
                placeholder="Enter user's secret access key"
                value={awsSecretKey}
                required={true}
              />
            </Col>

            <Col md={2} >
              <div className="form-group refresh-button-container">
                <Button
                  type="button"
                  className="update-keys"
                  onClick={handleUpdateKeys}
                >
                  Update
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </Col>
      <Col md={4} className="mt-4 mb-4">
        <div className="cc-card">
          <h2>My Timezone</h2>
          <Row>
            <Col md={7}>
              <FieldSelect
                label={`Timezone`}
                options={timezones}
                onChange={setTimezone}
                value={timezone}
                placeholder={`Choose the Timezone`}
                required={false}
              />
            </Col>
            <Col md={5} className="pt-3">
              <Button type="button" className="update-keys" onClick={handleUpdateTimezone}>
                Update
              </Button>
            </Col>
          </Row>
        </div>
      </Col>

    </Row>
  );
};
export default ChurchInfoAwsConnectionUpdate;
